import React from 'react';
import { Box } from '@mui/material';
import { ListingForm as ListingFormType } from '@/types';
import { GoogleMapsAddressInput, AddressData } from '@/components/common/GoogleMapsAddressInput';

interface LocationTabProps {
  formData: ListingFormType;
  errors: Record<string, string>;
  onFormDataChange: (updates: Partial<ListingFormType>) => void;
  onErrorsChange: (errors: Record<string, string>) => void;
  clearErrors: (fields: string[]) => void;
}

export const LocationTab: React.FC<LocationTabProps> = ({
  formData,
  errors,
  onFormDataChange,
  clearErrors,
}) => {
  const handleAddressChange = (addressData: AddressData) => {
    onFormDataChange({
      address: {
        ...formData.address,
        street: addressData.street,
        city: addressData.city,
        state: addressData.state,
        zipCode: addressData.zipCode,
        country: addressData.country,
        latitude: addressData.latitude,
        longitude: addressData.longitude,
      },
    });
    
    // Clear all address-related errors when address is updated
    clearErrors([
      'address.street',
      'address.city', 
      'address.state',
      'address.zipCode',
      'address.country'
    ]);
  };

  // Convert formData.address to AddressData format
  const addressData: AddressData = {
    street: formData.address?.street || '',
    city: formData.address?.city || '',
    state: formData.address?.state || '',
    zipCode: formData.address?.zipCode || '',
    country: formData.address?.country || 'United States',
    latitude: formData.address?.latitude,
    longitude: formData.address?.longitude,
  };
  


  return (
    <Box>
      <GoogleMapsAddressInput
        value={addressData}
        onChange={handleAddressChange}
        error={errors}
      />
    </Box>
  );
};

export default LocationTab;